import React, { Component } from "react";
import InlineOrderedBox from "./components/InlineOrderedBox";
import { graphql, compose } from "react-apollo";
import { queryGetResponseTimeGrowth, queryGetHandlingTimeGrowth } from "Apollo";
import { GetAnalyticFilter } from "Store";
import { observer } from "mobx-react";
import moment from "moment";
import { formatTimestampToUnitValue } from "./util";
import up from "./components/up.png";
import down from "./components/down.png";

const gqlOptions = {
  options: {
    fetchPolicy: "network-only"
  }
};

const Box = compose(
  graphql(queryGetResponseTimeGrowth, { ...gqlOptions, name: "responseTime" }),
  graphql(queryGetHandlingTimeGrowth, { ...gqlOptions, name: "handlingTime" })
)(
  class ResponseTimeAndHandlingTimeSummary extends Component {
    evaluateResponse(graphResponse, graphName) {
      let timeInfoFooter = "";
      let value = "00:00:00";
      if (!graphResponse.loading && graphResponse[graphName]) {
        const elem = graphResponse[graphName].data[0];
        if (elem) {
          let now = elem.details.find(item => item.name === "now");
          if (now) {
            if (now.value) {
              value = moment(now.value).format("HH:mm:ss");
            }
          }
          let absoluteValue = Math.abs(elem.value);
          let smallestTimeValueUnit = formatTimestampToUnitValue(absoluteValue);
          let fasterOrSlower = "";
          let imgArrow = "";
          if (elem.value > 0) {
            fasterOrSlower = "slower";
            imgArrow = <img alt="down" src={down} />;
          } else if (elem.value < 0) {
            fasterOrSlower = "faster";
            imgArrow = <img alt="up" src={up} />;
          }

          // timeInfoFooter = `${smallestTimeValueUnit[0]} ${smallestTimeValueUnit[1]} ${fasterOrSlower}`;

          timeInfoFooter = (
            <div>
              {imgArrow} <span />
              {smallestTimeValueUnit[0]} {smallestTimeValueUnit[1]}{" "}
              {fasterOrSlower}
            </div>
          );
        }
      }
      return [value, timeInfoFooter];
    }

    render() {
      const { responseTime, handlingTime } = this.props;
      let responseTimeTuple = this.evaluateResponse(
        responseTime,
        "getResponseTimeGrowth"
      );
      let handlingTimeTuple = this.evaluateResponse(
        handlingTime,
        "getHandlingTimeGrowth"
      );
      let responseTimeValue = responseTimeTuple[0];
      let responseTimeInfoFooter = responseTimeTuple[1];
      let handlingTimeValue = handlingTimeTuple[0];
      let handlingTimeInfoFooter = handlingTimeTuple[1];
      let opt = {
        size: "large",
        contentList: [
          {
            title: "Response Time",
            mainContent: responseTimeValue,
            footer: {
              text: responseTimeInfoFooter
            }
          },
          {
            title: "Handling Time",
            mainContent: handlingTimeValue,
            footer: {
              text: handlingTimeInfoFooter
            }
          }
        ]
      };
      return <InlineOrderedBox {...opt} />;
    }
  }
);

export default observer(
  class BoxWithQuery extends Component {
    render() {
      return <Box {...GetAnalyticFilter()} />;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-analytics/ResponseTimeAndHandlingTimeSummary.js